<script lang="ts">
  import { client_config } from "../stores/store";
</script>

<div class="verbaflo-widget-thinking-container">
  <div class="verbaflo-widget-message-sender-container">
    <img
      src={$client_config?.client_logo_url ||
        "https://vf-assets.verbaflo.com/logo.png"}
      alt="Bot Profile"
      class="verbaflo-widget-bot-profile"
    />
    <!-- <div class="verbaflo-widget-bot-name">{$client_config?.bot_name}</div> -->
  </div>
  <div class="verbaflo-widget-message-box">
    <div class="verbaflo-widget-typing-indicator">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <circle cx="18" cy="12" r="0" fill="#000000">
          <animate
            attributeName="r"
            begin=".67"
            dur="1.5s"
            values="0;2;0;0"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="12" cy="12" r="0" fill="#000000">
          <animate
            attributeName="r"
            begin=".33"
            dur="1.5s"
            values="0;2;0;0"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="6" cy="12" r="0" fill="#000000">
          <animate
            attributeName="r"
            begin="0"
            dur="1.5s"
            values="0;2;0;0"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  </div>
</div>

<style>
  :global(#vfwidget .verbaflo-widget-thinking-container) {
    display: flex !important;
    align-items: flex-start !important;
    gap: 8px !important;
    z-index: 10 !important;
  }

  :global(#vfwidget .verbaflo-widget-message-sender-container) {
    display: flex !important;
    gap: 4px !important;
  }

  :global(#vfwidget .verbaflo-widget-bot-profile) {
    width: 24px !important;
    height: 24px !important;
    border-radius: 50% !important;
    object-fit: cover !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;
  }

  :global(#vfwidget .verbaflo-widget-message-box) {
    background-color: #f6f6f6 !important;
    border-radius: 8px !important;
    border-bottom-left-radius: 0 !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    padding: 10px !important;
    max-width: 280px !important;
  }

  :global(#vfwidget .verbaflo-widget-bot-name) {
    font-weight: 700 !important;
    color: #051133 !important;
    font-size: 14px !important;
    padding: 0 !important;
    margin: 0 !important;
    text-transform: none !important;
    line-height: 20px !important;
  }

  :global(#vfwidget .verbaflo-widget-typing-indicator) {
    display: inline-flex !important;
    flex-direction: column !important;
    word-break: break-word !important;
  }
</style>
